import axios, { AxiosResponse } from 'axios';
import config from "app-config/config.json";
import toast from 'react-hot-toast';
import { resetToastMessages, toastMessage } from './helpers';

const BASE_URL = config.WORKSPACE_API + `/api`;

let headers = {} as any;

export default class ApiService {

  static get = async (endpoint: string, token?: string) => {    
    try {
      const lang = localStorage.getItem('lang');
      headers['accept-language'] = (lang && lang !== '') ? lang : 'vi';
      headers['access-token'] = (token && token !== '') ? token : ''

      const response: AxiosResponse = await axios.get(`${BASE_URL}/${endpoint}`, { headers });
      return response.data.data;
    } catch (error: any) {
      console.log('ApiService error:', error);

      const lang = localStorage.getItem('lang');
      const generalMsg = lang === "vi" ? "Thực hiện yêu cầu không thành công" : "Execute request failed";
      const msg = error.response.data.message ? error.response.data.message : generalMsg;

      toastMessage(msg);

      if (error.response.data.status_code === 401) {
        const intervalLogout = setInterval(() => {
          forceLogoutUser();
          resetToastMessages();
          clearInterval(intervalLogout)
        }, 2000);
      }

      // Clear localstorage toast message
      const intervalToast = setInterval(() => {
        resetToastMessages();
        clearInterval(intervalToast);
      }, 2000);
      
      throw error.response.data;
    }
  }

  static post = async (endpoint: string, data: object, token?: string) => {
    try {
      const lang = localStorage.getItem('lang');
      headers['accept-language'] = (lang && lang !== '') ? lang : 'vi';
      headers['access-token'] = (token && token !== '') ? token : ''
      
      const response: AxiosResponse = await axios.post(`${BASE_URL}/${endpoint}`, data, { headers });
      return response.data.data;
    } catch (error: any) {
      if (error.response.data.status_code === 401) {
        const intervalLogout = setInterval(() => {
          forceLogoutUser();
          clearInterval(intervalLogout)
        }, 2000);
      }
      throw error.response.data;
    }
  }

  static put = async (endpoint: string, data: object, token?: string) => {
    try {
      const lang = localStorage.getItem('lang');
      headers['accept-language'] = (lang && lang !== '') ? lang : 'vi';
      headers['access-token'] = (token && token !== '') ? token : ''

      const response: AxiosResponse = await axios.put(`${BASE_URL}/${endpoint}`, data, { headers });
      return response.data.data;
    } catch (error: any) {
      if (error.response.data.status_code === 401) {
        const intervalLogout = setInterval(() => {
          forceLogoutUser();
          clearInterval(intervalLogout)
        }, 2000);
      }
      throw error.response.data;
    }
  }

  static uploadImage = async (postForm: any) => {
    let url = 'https://upload.raceez.vn/image/upload/single';

    const headers_upload_image = {
      'Content-Type': 'multipart/form-data',
    }

    try {
      const response: AxiosResponse = await axios.post(url, postForm, { headers: headers_upload_image });
      return response.data.result;
    } catch (error: any) {
      throw error.response.data;
    }
  }
};

const forceLogoutUser = () => {
  localStorage.removeItem("USER");;
  localStorage.setItem('expired', 'true');
  window.location.href = "/login";
}
